// eslint-disable-next-line @typescript-eslint/ban-types
export function pick<T extends object, U extends keyof T>(
  obj: T | null | undefined,
  keys: U[],
): Pick<T, U> {
  if (obj == null) {
    return {} as Pick<T, U>;
  }

  const newObject = {} as Pick<T, U>;

  let index = -1;
  const { length } = keys;

  while (++index < length) {
    const key = keys[index];
    const value = obj[key];

    if (value != null) {
      newObject[key] = value;
    }
  }

  return newObject;
}
